import { l } from '@manychat/manyui'

import Img1 from './assets/whatyoulose-1.svg'
import Img2 from './assets/whatyoulose-2.svg'
import Img3 from './assets/whatyoulose-3.svg'

export const WhatYouWillLoseItems = [
  {
    title: l.makeTranslate('Collect and nurture leads without limitations'),
    image: Img1,
    benefits: [
      l.makeTranslate('Unlimited contacts'),
      l.makeTranslate('No Branding'),
      l.makeTranslate('Advanced Growth Tools'),
      l.makeTranslate('Capture Emails & Phones'),
      l.makeTranslate('Contact segmentation'),
    ],
  },
  {
    title: l.makeTranslate('Engage across different channels'),
    image: Img2,
    benefits: [
      l.makeTranslate('All messaging apps'),
      l.makeTranslate('Email'),
      l.makeTranslate('SMS'),
    ],
  },
  {
    title: l.makeTranslate('Use advanced tools in your automations'),
    image: Img3,
    benefits: [
      l.makeTranslate('User Input'),
      l.makeTranslate('Conditions'),
      l.makeTranslate('Smart Delay'),
      l.makeTranslate('A/B Testing'),
    ],
  },
]
